import React from 'react';
import ControlBarButton from './ControlBarButton';
import * as styles from './ControlBarContributorsButton.module.scss';
import AvatarStack from '../components/AvatarStack';
import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';
import { useGetUser } from '../user/useAllUsers';

const POST_FRAGMENT = gql(`
  fragment ControlBarContributorsButton_post on Post {
    id
    owner {
      id
      ...useGetUser_user
    }
    contributors {
      id
      ...useGetUser_user
    }
  }
`);

interface ControlBarContributorsButtonProps
  extends Omit<React.ComponentProps<typeof ControlBarButton>, 'className'> {
  post: DocumentType<typeof POST_FRAGMENT>;
  children: React.ReactNode;
  avatarStackRef?: React.Ref<HTMLDivElement>;
}

const ControlBarContributorsButton = React.forwardRef<
  HTMLButtonElement & HTMLDivElement,
  ControlBarContributorsButtonProps
>(({ post, children, avatarStackRef, ...rest }, ref) => {
  const getUser = useGetUser();
  const users = [
    post.owner,
    ...post.contributors.filter(
      (contributor) => contributor.id !== post.owner.id,
    ),
  ].map(getUser);

  return (
    <ControlBarButton
      {...rest}
      ref={ref}
      className={styles.button}
      icon={
        <div ref={avatarStackRef}>
          <AvatarStack
            size={22}
            limit={4}
            items={users}
            spacing="tight"
            borderSize={2}
            countOverflowVariant="smallPill"
            noWrap
          />
        </div>
      }
    >
      {children}
    </ControlBarButton>
  );
});

export default ControlBarContributorsButton;
